import React, { Component } from 'react';
import './styles.css';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Grid, Paper, Typography, Button } from '@material-ui/core';
import axios from 'axios';
import Alert from '@material-ui/lab/Alert';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import api from '../../environment';

const useStyles = (theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(4, 0, 2),
    backgroundColor: XMEI_PRIMARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    height: '45px',
  },
  cssOutlinedInput: {
    '&$cssFocused $notchedOutline': {
      borderColor: '#8d8d8e',
    },
  },
  cssFocused: {},
  notchedOutline: {},
});

class RecuperarSenha extends Component {
  state = {
    email: '',
    open: true,
    mensagem: '',
    tipomsg: '',
  };

  handleSubmit = async () => {
    const { email } = this.state;

    if (email === '' || email === null) {
      this.setState({ tipomsg: 'warning' });
      this.setState({ mensagem: 'Digite seu email para redefinir sua senha!' });
      this.setState({ open: true });
    } else {
      await axios
        .post(`${api}/enviarEmailAlteracaoSenha`, {
          email,
        })
        .then((res) => {
          this.refs.email = '';
          this.setState({ email: '' });
          this.setState({ tipomsg: 'success' });
          this.setState({ mensagem: res.data.message });
          this.setState({ open: true });
        })
        .catch((err) => {
          this.refs.email = '';
          this.setState({ tipomsg: 'error' });
          this.setState({ mensagem: 'Erro ao enviar email.Tente novamente!' });
          this.setState({ open: true });
        });
    }
  };

  clickAlert = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;

    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: '100vh', backgroundColor: XMEI_PRIMARY_COLOR }}
      >
        {this.state.open && (
          <Alert
            severity={this.state.tipomsg}
            onClick={this.clickAlert}
            style={{ position: 'absolute', top: 30 }}
          >
            {this.state.mensagem}
          </Alert>
        )}

        <Paper
          elevation={10}
          style={{
            width: '480px',
            backgroundColor: '#FFF',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 30,
            paddingBottom: 30,
          }}
        >
          <div style={{ width: 250, marginBottom: 20 }}>
            <img
              src="/logo-black.png"
              alt="Xmei Logo"
              style={{
                display: 'block',
                width: '100%',
                height: 'auto',
              }}
            />
          </div>
          <Typography variant="h5" align="center" style={{ marginBottom: 30 }}>
            Esqueçeu sua senha?
          </Typography>
          <Typography
            variant="subtitle2"
            style={{
              color: '#5E6C84',
              fontWeight: 'bold',
              fontSize: 14,
              marginBottom: -10,
            }}
          >
            Enviaremos um link de recuperação para
          </Typography>
          <TextField
            id="email"
            ref="email"
            label="Insira o e-mail"
            margin="normal"
            variant="outlined"
            fullWidth
            onChange={(email) => {
              this.setState({ email: email.target.value });
            }}
            style={{
              marginBottom: 40,
            }}
            value={this.state.email}
            InputProps={{
              classes: {
                root: classes.cssOutlinedInput,
                focused: classes.cssFocused,
                notchedOutline: classes.notchedOutline,
              },
            }}
            InputLabelProps={{
              style: {
                color: '#9e9e9e',
              },
            }}
          />
          <Button
            variant="contained"
            color="primary"
            type="button"
            fullWidth
            onClick={this.handleSubmit}
            style={{
              backgroundColor: XMEI_PRIMARY_COLOR,
              color: '#FFF',
              fontWeight: 'bold',
              height: '45px',
            }}
          >
            Enviar
          </Button>
        </Paper>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(RecuperarSenha);
